import { Injectable } from '@angular/core';
import { ESidebarMode } from 'app/enums/sidebarmode.enum';
import { ISidebar, ISidebarBusySlot } from 'app/interfaces/sidebar.interface';
import { EventsService } from 'app/services/events.service';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppointmentSidebarService {
	isOpen = false;
	sidebar: ISidebar = null;
	onStateChanges: BehaviorSubject<any> = new BehaviorSubject<{
		isOpen: boolean;
		sidebar: ISidebar;
	}>({
		isOpen: false,
		sidebar: null,
	});

	constructor(public events: EventsService) {}

	async getSidebarAppointment(sidebar): Promise<ISidebar> {
		return this.events
			.getEvent(sidebar.id)
			.then((event) => {
				if (event.status === 'paid') {
					const editSidebar = {
						mode: ESidebarMode.Edit,
						date: event.day,
						time: DateTime.fromISO(event.startTime).toJSDate(),
						id: sidebar.id,
						contactId: event.contactId,
						price: event.price,
						address: event.professionalAddress
							? event.professionalAddress.id
							: null,
					};
					return editSidebar;
				}
			})
			.catch(() => {
				return sidebar;
			});
	}

	async setSidebar(
		isOpen: boolean,
		sidebar: ISidebar | ISidebarBusySlot,
		isBusySlot = false
	) {
		if (isBusySlot) {
			return this.openSidebar({ ...sidebar, isBusySlot }, isOpen);
		}

		if (isOpen && sidebar) {
			const _sidebar = sidebar;
			if (sidebar.mode === ESidebarMode.Edit) {
				this.getSidebarAppointment(sidebar).then((editSidebar) => {
					this.openSidebar(editSidebar, isOpen);
				});
			} else {
				this.openSidebar(_sidebar, isOpen);
			}
		}
	}

	openSidebar(sidebar, isOpen) {
		this.sidebar = { ...sidebar };
		this.isOpen = isOpen;
		this.onStateChanges.next({
			isOpen: this.isOpen,
			sidebar: this.sidebar,
		});
	}

	getEmptySidebar() {
		return {
			mode: ESidebarMode.New,
			date: new Date(),
			time: new Date(),
			id: null,
			contactId: null,
		};
	}
}
